import React from 'react';

interface StepIndicatorProps {
  step: number | string;
}

const STEPS = [
  { id: 1, label: 'Phone' },
  { id: 2, label: 'Verify' },
  { id: 3, label: 'Type' },
  { id: 4, label: 'Schedule' },
  { id: 5, label: 'Confirmed' },
];

function stepIndex(step: number | string): number {
  if (step === 1) return 0;
  if (step === '2a' || step === '2b') return 1;
  if (step === '2c') return 2;
  if (step === 3) return 3;
  return 4;
}

export default function StepIndicator({ step }: StepIndicatorProps) {
  const current = stepIndex(step);

  return (
    <nav aria-label="Progress" className="mb-8">
      <ol className="flex items-center justify-between">
        {STEPS.map((s, i) => {
          const isComplete = i < current;
          const isCurrent = i === current;

          return (
            <li key={s.id} className="flex-1 flex flex-col items-center relative">
              {/* Connector line */}
              {i < STEPS.length - 1 && (
                <div
                  className={`absolute top-4 left-1/2 w-full h-0.5 ${
                    isComplete ? 'bg-primary' : 'bg-gray-200'
                  }`}
                  style={{ zIndex: 0 }}
                />
              )}

              {/* Circle */}
              <div
                className={`relative z-10 w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs sm:text-sm font-semibold border-2 transition-colors ${
                  isComplete
                    ? 'bg-primary border-primary text-white'
                    : isCurrent
                    ? 'bg-white border-primary text-primary-deep'
                    : 'bg-white border-gray-300 text-gray-500'
                }`}
              >
                {isComplete ? (
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  s.id
                )}
              </div>

              {/* Label */}
              <span
                className={`mt-1.5 text-[10px] sm:text-xs font-medium ${
                  isCurrent ? 'text-primary-deep' : isComplete ? 'text-gray-600' : 'text-gray-500'
                }`}
              >
                {s.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
